import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Spinner} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {useLogger} from '../../../../../hooks/logger'
import {useAppActions, useAppSelector} from '../../../../../hooks/runtime'
import {getDownloadTicketsUrl, getLoadingTicketsUrl, getTickets} from '../../../../../selectors/placed-order'
import {Interaction} from '../../../../../services/logger'
import cl from '../../../../classnames.scss'
import {classes} from './download-papyrus-tickets.st.css'
import {DownloadPapyrusTicketsProps} from './interfaces'

const DOWNLOAD_RETRY_LIMIT = 10

export const DownloadPapyrusTickets = ({className}: DownloadPapyrusTicketsProps) => {
  const {t} = useTranslation()
  const {openTicketsDownloadModal, getOrderTicketsDownloadUrl} = useAppActions()
  const {isMobile} = useEnvironment()

  const downloadTicketsUrl = useAppSelector(getDownloadTicketsUrl)
  const loadingTicketsUrl = useAppSelector(getLoadingTicketsUrl)
  const tickets = useAppSelector(getTickets)
  const logger = useLogger()

  useEffect(() => {
    const init = () => {
      logger.startInteraction(Interaction.LoadingTickets)
      getOrderTicketsDownloadUrl(DOWNLOAD_RETRY_LIMIT)
    }

    init()
  }, [])

  const handleClick = async () => {
    if (downloadTicketsUrl) {
      if (isMobile) {
        openTicketsDownloadModal()
      } else {
        window.open(downloadTicketsUrl)
      }
    } else {
      getOrderTicketsDownloadUrl(DOWNLOAD_RETRY_LIMIT)
    }
  }

  return loadingTicketsUrl ? (
    <div className={classes.loaderContainer} data-hook={DH.PREPARING_TICKETS}>
      <Spinner diameter={20} className={classes.spinner} />
      <div className={classNames(cl.formLabelsFont, cl.formLabelsColor)}>
        {t('ticketsThankYou.preparingTickets', {count: tickets.length})}
      </div>
    </div>
  ) : (
    <button className={className} data-hook={DH.DOWNLOAD_TICKETS} onClick={handleClick}>
      {t('ticketsThankYou.downloadTickets', {count: tickets.length})}
    </button>
  )
}
